<template>
  <figure class="image-group">
    <el-image
      :src="url"
      :style="`height: ${height}; width: ${width}`"
      fit="scale-down"
    >
      <div slot="placeholder" class="image-slot">
        <div class="skeleton">
          <skeleton-theme
            :color="skeleton.color"
            :highlight="skeleton.highlight"
            :style="`height: ${skeleton.size}; width: ${skeleton.size}`"
          >
            <skeleton :height="skeleton.size" :width="skeleton.size" circle />
          </skeleton-theme>
          <div
            :style="
              `height: ${skeleton.innerSize}; width: ${skeleton.innerSize}; border-radius: ${skeleton.innerSize}`
            "
            class="inner-circle"
          ></div>
        </div>
      </div>
      <div slot="error" class="image-slot error">
        <ck-icon name="ico-image-failed-56px" size="56px" />
      </div>
    </el-image>
  </figure>
</template>

<script>
import ElImage from 'element-ui/lib/image'
export default {
  components: {
    ElImage
  },
  props: {
    url: {
      type: String,
      required: true
    },
    srcset: String,
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    }
  },
  data() {
    return {
      skeleton: {
        color: '#f4fbfe',
        highlight: '#EDEFF6',
        size: '34px',
        innerSize: '26px'
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import (reference) '~@/assets/less/main.less';

.image-group {
  .lh-display(flex);
  .lh-align-items(center);
  .lh-justify-content(center);

  .image-slot.error {
    .lh-display(flex);
    .lh-align-items(center);
    .lh-justify-content(center);
    height: 100%;
  }

  ::v-deep {
    .lh-display(flex);
    .lh-align-items(center);
    .lh-justify-content(center);
  }
}

.skeleton {
  &,
  > * {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
}

.inner-circle {
  background-color: @white;
  top: 2px;
}
</style>
